import { WalletSkeletonWhiteBox } from "../../../../style/skeleton";
import {
  WalletLogsListItem,
  WalletLogsListItemInfo,
  WalletLogsListItemWrapper,
  WalletLogsListRow,
  WalletLogsListWrapper,
  WalletLogsRowBorder,
} from "./style";

const WalletLogsListSkeleton = () => {
  return (
    <WalletLogsListWrapper>
      {Array.from({ length: 5 }, (_, index) => (
        <>
          <WalletLogsListRow key={index}>
            <WalletSkeletonWhiteBox width="30px" />
            <WalletLogsListItemWrapper>
              {Array.from(
                { length: index === 1 ? 4 : index === 3 ? 2 : 3 },
                (_, i) => (
                  <WalletLogsListItem key={i}>
                    <WalletLogsListItemInfo>
                      <WalletSkeletonWhiteBox width="100px" />
                      <WalletSkeletonWhiteBox width="50px" />
                    </WalletLogsListItemInfo>
                    <div className="point">
                      <WalletSkeletonWhiteBox width="60px" />
                    </div>
                  </WalletLogsListItem>
                )
              )}
            </WalletLogsListItemWrapper>
          </WalletLogsListRow>
          <WalletLogsRowBorder />
        </>
      ))}
    </WalletLogsListWrapper>
  );
};

export default WalletLogsListSkeleton;
